import React from 'react';
import './InfraPalette.css';

/**
 * Component Palette - Draggable infrastructure components
 */
const InfraPalette = () => {
  const components = [
    {
      type: 'agent',
      icon: '🖥️',
      label: 'Agent',
      description: 'Beacon agent running on target system'
    },
    {
      type: 'redirector',
      icon: '🔄',
      label: 'Redirector',
      description: 'Traffic proxy/redirector (NGINX, Apache, etc.)'
    },
    {
      type: 'listener',
      icon: '📡',
      label: 'Listener',
      description: 'C2 listener (HTTP, HTTPS, DNS, SMB)'
    },
    {
      type: 'c2',
      icon: '⚙️',
      label: 'C2 Server',
      description: 'Main C2 server (this server)'
    }
  ];

  const handleDragStart = (event, type) => {
    event.dataTransfer.setData('nodeType', type);
    event.dataTransfer.effectAllowed = 'copy';
  };

  return (
    <div className="infra-palette">
      <div className="palette-header">
        <h3>Components</h3>
        <small>Drag to canvas</small>
      </div>
      <div className="palette-items">
        {components.map((component) => (
          <div
            key={component.type}
            className="palette-item"
            draggable
            onDragStart={(e) => handleDragStart(e, component.type)}
          >
            <div className="palette-item-icon">{component.icon}</div>
            <div className="palette-item-content">
              <div className="palette-item-label">{component.label}</div>
              <div className="palette-item-description">{component.description}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="palette-footer">
        <div className="palette-tip">
          <strong>Tip:</strong> Right-click a node on canvas to start linking
        </div>
      </div>
    </div>
  );
};

export default InfraPalette;
